<template>
  <div class="page">
    <commonHeader heading="数据概览"></commonHeader>
    <!-- 课程数据 -->
    <div class="big-title">
      <div class="left-title">课程数据</div>
      <div class="right-detail" @click="toCourseData()">
        <div class="title">查看详情</div>
        <md-icon class="title-icon">keyboard_arrow_right</md-icon>
      </div>
    </div>
    <div class="course-data">
      <div class="course-row">
        <v-card>
          <div class="course-header">
            <div class="header-title">全部课程</div>
            <!-- <div class="header-date"></div> -->
            <div class="header-btn">
              <span class="mdi mdi-fullscreen" @click="fullScreenDisplay('coursePieChart')"></span>
            </div>
          </div>
          <div class="course-echart">
            <div id="coursePieChart"></div>
          </div>
        </v-card>
      </div>
      <div class="course-row">
        <v-card>
          <div class="course-header">
            <div class="header-title">课程覆盖的产业集群</div>
            <!-- <div class="header-date"></div> -->
            <div class="header-btn">
              <span class="mdi mdi-fullscreen" @click="fullScreenDisplay('courseHistogram')"></span>
            </div>
          </div>
          <div class="course-echart">
            <div id="courseHistogram"></div>
          </div>
        </v-card>
      </div>
      <div class="course-row">
        <v-card>
          <div class="course-header">平台课程热度榜</div>
          <div class="course-echart" style="text-align: left;">
            <div id="hot-list">
              <div class="hot-row">
                <div class="index">1</div>
                <div class="z-title">旅游咨询员</div>
                <div class="type">服务业</div>
                <div class="study">
                  <span class="num">900</span>
                  <span class="character">学习人次</span>
                </div>
              </div>
              <div class="hot-row">
                <div class="index">2</div>
                <div class="z-title">无人机驾驶员</div>
                <div class="type">无人机</div>
                <div class="study">
                  <span class="num">800</span>
                  <span class="character">学习人次</span>
                </div>
              </div>
              <div class="hot-row">
                <div class="index">3</div>
                <div class="z-title">电子商务师（网商）</div>
                <div class="type">电商</div>
                <div class="study">
                  <span class="num">700</span>
                  <span class="character">学习人次</span>
                </div>
              </div>
              <div class="hot-row">
                <div class="index">4</div>
                <div class="z-title">工业机器人系统操作员</div>
                <div class="type">智能制造</div>
                <div class="study">
                  <span class="num">650</span>
                  <span class="character">学习人次</span>
                </div>
              </div>
              <div class="hot-row">
                <div class="index">5</div>
                <div class="z-title">汽车维修工（新能源方向）</div>
                <div class="type">服务业</div>
                <div class="study">
                  <span class="num">500</span>
                  <span class="character">学习人次</span>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </div>
    </div>

    <!-- 学习数据 -->
    <div class="big-title">
      <div class="left-title">学习数据</div>
      <div class="right-detail" @click="toStudyData()">
        <div class="title">查看详情</div>
        <md-icon class="title-icon">keyboard_arrow_right</md-icon>
      </div>
    </div>
    <div class="course-data">
      <div class="course-row">
        <v-card>
          <div class="course-header">
            <div class="header-title">
              平台新增用户数
            </div>
            <div class="header-date">
              <v-menu
                v-model="studyAddDateMenu" 
                :close-on-content-click="false"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    style="width: 220px;"
                    hide-details
                    prepend-icon="mdi-calendar" 
                    v-model="studyAddDateText"  
                    readonly
                    placeholder="时间区间"
                    :dense="true"
                    v-bind="attrs" 
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker 
                  range 
                  locale="zh-cn" 
                  v-model="studyAddDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="cancelDateCallback('studyAddDate')"
                  >
                    取消
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="confirmDateCallback('studyAddDate')"
                  >
                    确认
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="header-btn">
              <span class="mdi mdi-fullscreen" @click="fullScreenDisplay('studyAdd')"></span>
            </div>
          </div>
          <div class="course-echart">
            <div id="studyAdd"></div>
          </div>
        </v-card>
      </div>
      <div class="course-row">
        <v-card>
          <div class="course-header">
            <div class="header-title">平台课程学习人数</div>
            <div class="header-date">
              <v-menu 
                v-model="studyAllDateMenu" 
                :close-on-content-click="false"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    style="width: 220px;"
                    hide-details
                    prepend-icon="mdi-calendar" 
                    v-model="studyAllDateText"  
                    readonly
                    placeholder="时间区间"
                    :dense="true"
                    v-bind="attrs" 
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker 
                  range 
                  locale="zh-cn" 
                  v-model="studyAllDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="cancelDateCallback('studyAllDate')"
                  >
                    取消
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="confirmDateCallback('studyAllDate')"
                  >
                    确认
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="header-btn">
              <span class="mdi mdi-fullscreen" @click="fullScreenDisplay('studyAll')"></span>
            </div>
          </div>
          <div class="course-echart">
            <div id="studyAll"></div>
          </div>
        </v-card>
      </div>
    </div>

    <!-- 考试数据 -->
    <div class="big-title">
      <div class="left-title">考试数据</div>
      <div class="right-detail" @click="toExamData()">
        <div class="title">查看详情</div>
        <md-icon class="title-icon">keyboard_arrow_right</md-icon>
      </div>
    </div>
    <div class="course-data" style="margin-bottom: 15px;">
      <div class="course-row">
        <v-card>
          <div class="course-header">
            <div class="header-title">
              参与考试人数
            </div>
            <div class="header-date">
              <v-menu 
                v-model="examDataDateMenu" 
                :close-on-content-click="false"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    style="width: 220px;"
                    hide-details
                    prepend-icon="mdi-calendar" 
                    v-model="examDataDateText"  
                    readonly
                    placeholder="时间区间"
                    :dense="true"
                    v-bind="attrs" 
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker 
                  range 
                  locale="zh-cn" 
                  v-model="examDataDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="cancelDateCallback('examDataDate')"
                  >
                    取消
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="confirmDateCallback('examDataDate')"
                  >
                    确认
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="header-btn">
              <span class="mdi mdi-fullscreen" @click="fullScreenDisplay('examData')"></span>
            </div>
          </div>
          <div class="course-echart">
            <div id="examData"></div>
          </div>
        </v-card>
      </div>
    </div>
    <div class="course-data">
      <div class="course-row">
        <v-card>
          <div class="course-header">
            <div class="header-title">
              考试及格率
            </div>
            <div class="header-date">
              <v-menu 
                v-model="examPassRateDateMenu" 
                :close-on-content-click="false"
                offset-y 
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    style="width: 220px;"
                    hide-details
                    prepend-icon="mdi-calendar" 
                    v-model="examPassRateDateText"  
                    readonly
                    placeholder="时间区间"
                    :dense="true"
                    v-bind="attrs" 
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker 
                  range 
                  locale="zh-cn" 
                  v-model="examPassRateDate"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="cancelDateCallback('examPassRateDate')"
                  >
                    取消
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="confirmDateCallback('examPassRateDate')"
                  >
                    确认
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </div>
            <div class="header-btn">
              <span class="mdi mdi-fullscreen" @click="fullScreenDisplay('examPassRate')"></span>
            </div>
          </div>
          <div class="course-echart">
            <div id="examPassRate"></div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import CommonHeader from '@/components/DataService/CommonHeader.vue';
import { mapGetters } from 'vuex';
export default {
  components: {
    CommonHeader
  },
  data() {
    return {

      studyAddDateMenu: false,
      studyAddDateText: [],
      studyAddDate: [],

      studyAllDateMenu: false,
      studyAllDateText: [],
      studyAllDate: [],

      examDataDateMenu: false,
      examDataDateText: [],
      examDataDate: [],

      examPassRateDateMenu: false,
      examPassRateDateText: [],
      examPassRateDate: [],

      coursePieChart: null,
      courseHistogram: null,
      studyAdd: null,
      studyAll: null,
      examData: null,
      examPassRate: null,

    };
  },
  computed: {
    ...mapGetters(['isMobile']),
    // studyAddDateText () {
    //     return this.studyAddDate.join('~')
    // },
  },
  watch: {
    'isMobile.isMobile'(news) {
      if (!news) {
        setTimeout(() => {
          this.coursePieChart.dispose();
          this.courseHistogram.dispose();
          this.studyAdd.dispose();
          this.studyAll.dispose();
          this.examData.dispose();
          this.examPassRate.dispose();
          this.getCoursePieChart();
          this.getCourseHistogram();
          this.getStudyAdd()
          this.getStudyAll()
          this.getExamData()
          this.getExamPassRate()
        }, 500);
      }
    },
  },

  created() {

  },

  mounted() {
    this.getCoursePieChart()
    this.getCourseHistogram()
    this.getStudyAdd()
    this.getStudyAll()
    this.getExamData()
    this.getExamPassRate()
  },

  methods: {
    // 确定时间区间回调
    confirmDateCallback(str) {
      this[`${str}Text`] = this[str].join('~')
      this[`${str}Menu`] = false
    },
    // 取消时间区间回调
    cancelDateCallback(str) {
      this[`${str}Menu`] = false
    },
    getCoursePieChart() {
      this.coursePieChart = echarts.init(document.getElementById('coursePieChart'));
      var option;

      option = {
        tooltip: {
          trigger: 'item'
        },

        legend: {
          top: '0%',
          left: 'center'
        },
        series: [
          {
            name: 'Access From',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2
            },
            // 是否显示箭头指引
            label: {
              show: true,
              // position: 'center'
            },
            emphasis: {
              // label: {
              //   show: true,
              //   fontSize: 40,
              //   fontWeight: 'bold'
              // },
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            labelLine: {
              show: true
            },
            data: [
              { value: 1048, name: '特色产业培训课程' },
              { value: 735, name: '高级培训课程' },
            ]
          }
        ]
      };

      this.coursePieChart.setOption(option);

      // 根据页面大小自动响应图表大小
      let _this = this;
      window.addEventListener('resize', function () {
        _this.coursePieChart.resize();
      });

    },
    getCourseHistogram() {
      this.courseHistogram = echarts.init(document.getElementById('courseHistogram'));
      var option;

      option = {
        xAxis: {
          type: 'category',
          data: ['纺织服装', '畜牧业与农夫产品加工', '旅游', '光伏', '冷源化工', '现代服务业', '物流']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: [5, 8, 12, 7, 9, 3, 1],
            type: 'bar'
          }
        ]
      };

      this.courseHistogram.setOption(option);

      // 根据页面大小自动响应图表大小
      let _this = this;
      window.addEventListener('resize', function () {
        _this.courseHistogram.resize();
      });
    },
    getStudyAdd() {
      this.studyAdd = echarts.init(document.getElementById('studyAdd'));
      var option;

      option = {
        title: {
          // text: 'Step Line'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['平台新增注册人数']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        // 是否下载图片
        // toolbox: {
        //   feature: {
        //     saveAsImage: {}
        //   }
        // },
        xAxis: {
          type: 'category',
          data: ['9月1日', '9月1日', '9月1日', '9月1日', '9月1日', '9月1日', '9月1日']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '平台新增注册人数',
            type: 'line',
            step: 'start',
            data: [120, 132, 101, 134, 90, 230, 210]
          },
        ]
      };

      this.studyAdd.setOption(option);

      // 根据页面大小自动响应图表大小
      let _this = this;
      window.addEventListener('resize', function () {
        _this.studyAdd.resize();
      });
    },
    getStudyAll() {
      this.studyAll = echarts.init(document.getElementById('studyAll'));
      var option;

      option = {
        title: {
          // text: 'Stacked Area Chart'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          }
        },
        legend: {
          data: ['参与课程学习人数', '课程学习结业人数']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [
          {
            type: 'category',
            // boundaryGap: false,
            data: ['9月1日', '9月1日', '9月1日', '9月1日', '9月1日', '9月1日', '9月1日']
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: [
          {
            name: '参与课程学习人数',
            type: 'line',
            stack: 'Total',
            smooth: true,
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: '课程学习结业人数',
            type: 'line',
            stack: 'Total',
            smooth: true,
            areaStyle: {},
            emphasis: {
              focus: 'series'
            },
            data: [220, 182, 191, 234, 290, 330, 310]
          }
        ]
      };

      this.studyAll.setOption(option);

      // 根据页面大小自动响应图表大小
      let _this = this;
      window.addEventListener('resize', function () {
        _this.studyAll.resize();
      });
    },
    getExamData() {
      this.examData = echarts.init(document.getElementById('examData'));
      var option;

      option = {
        title: {
          // text: 'Stacked Line'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['参与测试人数', '测试及格人数']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['8月22日', '8月22日', '8月22日', '8月22日', '8月22日', '8月22日', '8月22日']
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '参与测试人数',
            type: 'line',
            stack: 'Total',
            data: [120, 132, 101, 134, 90, 230, 210]
          },
          {
            name: '测试及格人数',
            type: 'line',
            stack: 'Total',
            data: [220, 182, 191, 234, 290, 330, 310]
          },
        ]
      };

      this.examData.setOption(option);

      // 根据页面大小自动响应图表大小
      let _this = this;
      window.addEventListener('resize', function () {
        _this.examData.resize();
      });
    },
    getExamPassRate() {
      this.examPassRate = echarts.init(document.getElementById('examPassRate'));
      var option;

      option = {
        title: {
          // text: 'Stacked Line'
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['测试及格率']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: ['8月1日', '8月2日', '8月3日', '8月4日', '8月5日',]
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            name: '测试及格率',
            type: 'line',
            stack: 'Total',
            data: [0.00, 20.00, 100.00, 80.00, 50.00, 30.00, 10.00],
            // data: ['0.00%', '90.00%', '50.00%', '70.00%', '30.00%'],
          },
        ]
      };

      this.examPassRate.setOption(option);

      // 根据页面大小自动响应图表大小
      let _this = this;
      window.addEventListener('resize', function () {
        _this.examPassRate.resize();
      });
    },
    fullScreenDisplay(id) {
      var element = document.getElementById(id);
      var requestFullScreen = element.requestFullScreen || element.webkitRequestFullScreen || element.mozRequestFullScreen || element.msRequestFullscreen;
      if (requestFullScreen) {
          // 进入全屏
          requestFullScreen.call(element);
      }

      if (id == "courseHistogram") {
        let _this = this;
        window.addEventListener('resize', function () {
          _this.coursePieChart.resize();
        });
      }
    },
    toCourseData() {
      this.$router.push({
        name: 'CourseDataTable',
        query: {
          detailId: 1,
        },
      });
    },
    toStudyData() {
      this.$router.push({
        name: 'StudyDataTable',
        query: {
          detailId: 1,
        },
      });
    },
    toExamData() {
      this.$router.push({
        name: 'ExamDataTable',
        query: {
          detailId: 1,
        },
      });
    },
  }
}
</script>


<style scoped>
.page {
  padding: 10px 15px;

  .big-title {
    display: flex;
    padding: 20px 0px 5px 15px;
    align-items: center;

    .left-title {    
      height: 30px;
      line-height: 30px;
      font-size: 18px;
      flex: 1;
      text-align: left;
    }

    .right-detail {
      cursor: pointer;
      text-align: right;
      display: flex;
      height: 30px;
      line-height: 30px;
      .title {
        font-size: 16px !important;
        flex: 1;
      }

      .title-icon {
        font-size: 20px !important;
      }
    }
  }
  
  .course-data {
    display: flex;
    column-gap: 10px;
    justify-content: space-between;
    .course-row {
      flex: 1;
      .v-card {
        height: 100%;
      }
      .course-header {
        display: flex;
        padding: 10px 15px;
        .header-title {
          font-size: 16px;
          flex: 1;
          height: 30px;
          line-height: 30px;
        }
        .header-date {
          flex: 1.4;
          .v-text-field {
            margin-top: 0;
          }
        }
        .header-btn {
          width: 30px;
          text-align: right;
          cursor: pointer;
          font-size: 20px;
        }
      }

      .course-echart {
        text-align: center;
        overflow-y: auto;
        #coursePieChart,
        #courseHistogram {
          display: inline-block;
          width: 100%;
          height: 200px;
        }

        #studyAdd,
        #studyAll {
          display: inline-block;
          width: 100%;
          height: 350px;
        }

        #examData,
        #examPassRate {
          display: inline-block;
          width: 100%;
          height: 350px;
        }

        #hot-list {
          width: 100%;
          display: inline-block;
          padding: 15px 10px 0 10px;

          .hot-row {
            width: 100%;
            display: flex;
            margin-bottom: 10px;
            box-sizing: border-box;
            .index {
              text-align: center;
              height: 25px;
              line-height: 22px;
              padding: 2px 10px;
              margin-right: 5px;
              color: #fff;
              border: 1px solid #ccc;
              border-radius: 3px;
              background-color: rgb(244, 34, 34);

            }

            .z-title {
              text-align: left;
              font-size: 18px;
              color: #000;
              font-weight: 700;
              flex: 1;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            .type {
              text-align: center;
              width: 100px;
              line-height: 25px;
              font-size: 16px;
              font-style: italic;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            .study {
              width: 120px;
              text-align: right;
              font-size: 16px;
            }
          }
        }
      }
    }
  }

  @media (max-width: 1000px) {
    .course-data {
      display: block;
    }
  }
}
</style>

<style scoped></style>